'use client';

import { joinClassNames, WithClassnames } from '@vertex-protocol/web-common';

interface Props extends WithClassnames {
  /** The size of the icon — kept for API compatibility but not used by this animation */
  size: number;
  /** If true, removes saturation and lowers opacity */
  grayscale?: boolean;
}

const BAR_BASE_STYLE: React.CSSProperties = {
  position: 'absolute',
  width: '95px',
  height: '8px',
  backgroundColor: '#ffa02d',
  boxShadow: '0 10px 15px -3px rgba(255,160,45,0.5)',
  animationName: 'stack-bar-drop',
  animationTimingFunction: 'ease-out',
  animationDuration: '2.1s',
  animationIterationCount: 'infinite',
  opacity: 0,
};

// 4 bars: each drops sequentially, alternating left/right alignment
const BARS: { bottom: number; left?: 0; right?: 0; delay: string }[] = [
  { bottom: 0, left: 0, delay: '0.3s' },
  { bottom: 12, right: 0, delay: '0.6s' },
  { bottom: 24, left: 0, delay: '0.9s' },
  { bottom: 36, right: 0, delay: '1.2s' },
];

export function BrandIconLoadingIndicator({
  grayscale,
  className,
}: Props) {
  return (
    <div
      className={joinClassNames(
        'flex justify-center',
        grayscale && 'opacity-20 saturate-0',
        className,
      )}
    >
      <div style={{ position: 'relative', width: '140px', height: '64px' }}>
        {BARS.map((bar, i) => (
          <div
            key={i}
            style={{
              ...BAR_BASE_STYLE,
              bottom: bar.bottom,
              left: bar.left,
              right: bar.right,
              animationDelay: bar.delay,
            }}
          />
        ))}
      </div>
    </div>
  );
}
